import { ChangeEvent, FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { TemplateFlexGridContainer } from '../../../components/Grid';
import { Heading } from '../../../components/Heading';
import { Input } from '../../../components/Input';
import { InputGroup } from '../../../components/InputGroup';
import { RadioGroup } from '../../../components/RadioGroup';
import { StepProps } from '../../../types';
import { useBriefingState } from '../BriefingState';

export const StepProductDetails: FC<StepProps> = ({ mandatoryFields }) => {
  const { t } = useTranslation();
  const [
    {
      finishedProductSamples,
      finishedProductPotential,
      requiredSampleTime,
      projectDeadline,
    },
    {
      setFinishedProductSamples,
      setFinishedProductPotential,
      setProjectDeadline,
      setRequiredSampleTime,
    },
  ] = useBriefingState();
  const dispatch = useDispatch();

  const [isNeeded, setIsNeeded] = useState(false);

  useEffect(() => {
    setIsNeeded(finishedProductSamples === 'Yes');
  }, [finishedProductSamples]);

  return (
    <TemplateFlexGridContainer.BriefingStep>
      <Heading
        level="h1"
        margin={0}
        text={t(`topics:product-details:heading:general`)}
        optionalField={mandatoryFields['problem']?.length === 0}
      />
      <TemplateFlexGridContainer.BriefingStepBody>
        <div className="w-full md:w-8/12">
          <div className="space-y-6">
            <div>
              <RadioGroup
                label={t(
                  `topics:product-details:finishedProductSamples:heading`,
                )}
                onChange={(selectedValue: string | null) => {
                  dispatch(setFinishedProductSamples(selectedValue));
                }}
                initialSelection={finishedProductSamples}
                radioOptions={[
                  {
                    label: t(
                      `topics:product-details:finishedProductSamples:answer:yes`,
                    ),
                    value: t(
                      `topics:product-details:finishedProductSamples:answer:yes`,
                    ),
                  },
                  {
                    label: t(
                      `topics:product-details:finishedProductSamples:answer:no`,
                    ),
                    value: t(
                      `topics:product-details:finishedProductSamples:answer:no`,
                    ),
                  },
                ]}
              />
            </div>

            <div>
              {isNeeded && (
                <InputGroup
                  label={t(
                    'topics:product-details:finishedProductSamples:requiredTimeForSample',
                  )}
                  optional={true}
                >
                  <div className="w-full">
                    <Input
                      initialValue={requiredSampleTime}
                      type="text"
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        dispatch(setRequiredSampleTime(e.target.value));
                      }}
                    />
                  </div>
                </InputGroup>
              )}
            </div>

            <div>
              <InputGroup
                label={t(`topics:product-details:finishedProductPotential`)}
              >
                <div className="w-full">
                  <Input
                    initialValue={finishedProductPotential}
                    type="text"
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      dispatch(setFinishedProductPotential(e.target.value));
                    }}
                  />
                </div>
              </InputGroup>
            </div>

            <div>
              <InputGroup label={t(`topics:product-details:projectDeadline`)}>
                <div className="w-full">
                  <Input
                    initialValue={projectDeadline}
                    type="text"
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      dispatch(setProjectDeadline(e.target.value));
                    }}
                  />
                </div>
              </InputGroup>
            </div>
          </div>
        </div>
      </TemplateFlexGridContainer.BriefingStepBody>
    </TemplateFlexGridContainer.BriefingStep>
  );
};
